import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import ListItemText from "@mui/material/ListItemText";
// import Select, { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import EditIcon from "../../../assets/icons/newEdit.svg";
// import UpArrow from "../../../assets/icons/up-arrow.svg";
import DownArrow from "../../../assets/icons/arrow.svg";
import { IconButton } from "@material-ui/core";

// function CustomIcon({ category, list }) {
//   const data = list.filter((item) => item.type === category);

//   return (
//     <div>
//       {data.length}
//       <img src={EditIcon} alt={`Image`} className="product-image" />
//     </div>
//   );
// }

export default function CheckboxesTags(props) {
  const [inputValue, setInputValue] = useState("");

  // Clear input text when all filters are reset
  React.useEffect(() => {
    if (props.selectedValues.length === 0) {
      setInputValue("");
    }
  }, [props.selectedValues]);

  // const values = props.FilterCategory.values;
  //this is used for filtercategory Uid Array
  const selectedUid = props.selectedValues
    .filter((item) => {
      return item.type === props.FilterCategory.type;
    })
    .map((ele) => ele.Uid);
  //for sorting array in selected order wise
  const values = props.selectedValues.length
    ? props.FilterCategory.values[0]?.label
      ? [
          ...props.FilterCategory.values.filter((x) =>
            selectedUid.includes(
              `${props.FilterCategory.type + x.id + x.label}`
            )
          ),
          ...props.FilterCategory.values.filter(
            (x) =>
              !selectedUid.includes(
                `${props.FilterCategory.type + x.id + x.label}`
              )
          ),
        ]
      : [
          ...props.FilterCategory.values.filter((x) =>
            selectedUid.includes(`${props.FilterCategory.type + x.id}`)
          ),
          ...props.FilterCategory.values.filter(
            (x) => !selectedUid.includes(`${props.FilterCategory.type + x.id}`)
          ),
        ]
    : props.FilterCategory.values;
  const dynamicCheckbox = (value) => {
    if (props.FilterCategory.values[0].label) {
      return props.selectedValues.findIndex(
        (data) =>
          data.Uid === `${props.FilterCategory.type + value.id + value.label}`
      ) > -1
        ? true
        : false;
    } else {
      return props.selectedValues.findIndex(
        (data) => data.Uid === `${props.FilterCategory.type + value.id}`
      ) > -1
        ? true
        : false;
    }
  };

  return (
    <Autocomplete
      size="small"
      multiple
      autoHighlight={false}
      sx={{
        width: { sm: 100, md: 130 + props.FilterCategory.type.length * 2 },
        "& .MuiInputBase-root": {
          height: 30,
        },
      }}
      popupIcon={
        <IconButton className="popup-icon">
          <img src={DownArrow} alt="Edit Icon Image" />
        </IconButton>
      }
      id="checkboxes-tags-demo"
      options={values}
      disableCloseOnSelect={props.multi}
      componentsProps={{
        paper: {
          sx: {
            width: 180,
          },
        },
      }}
      value={[]}
      inputValue={inputValue}
      clearOnBlur={false}
      onInputChange={(_event, newInputValue, reason) => {
        if (reason === "input") {
          setInputValue(newInputValue);
        }
      }}
      includeInputInList={true}
      renderTags={() => null}
      onChange={(event, valueObject) =>
        props.handleChange(
          event,
          valueObject,
          props.FilterCategory.type,
          props.multi
        )
      }
      getOptionLabel={(option) => `${option.name}+${option.id}`}
      renderOption={(data, option, { selected }) => (
        <li {...data}>
          {props.multi ? (
            <>
              <Checkbox
                style={{ marginRight: 5, padding: "0px 0px 0px 0px" }}
                checked={dynamicCheckbox(option)}
                onChange={(ev) => props.checkBoxChangeHandler(ev, option)}
              />

              <span
                onChange={(ev) => props.checkBoxChangeHandler(ev, option)}
                style={{ fontSize: "10px" }}
              >
                {option.value_to_show ? option.value_to_show : option.name}
              </span>
            </>
          ) : (
            <>
              <input type="radio" checked={dynamicCheckbox(option)} />
              &nbsp; &nbsp;
              <span
                style={{
                  fontSize: "10px",
                }}
              >
                {option.value_to_show ? option.value_to_show : option.name}
              </span>
            </>
          )}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label={props.FilterCategory.type}
          InputLabelProps={{ style: { fontSize: 12 } }}
        />
      )}
    />
  );
}
